import { Outlet } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function ProtectedRoute({ isAuthenticated, children, redirect }) {

    let location = useLocation();

    if (!isAuthenticated) return <Navigate to={redirect} state={{ from: location }} replace />;

    return children ? children : <Outlet />;
}
